import  React from 'react'
import Button from 'react-bootstrap/Button'

export interface NextBackButtonsProps {
    nextLabel?: string
    nextDisabled?: boolean
    backLabel?: string
    onBack?: { (): any }
    onNext?: { (): any }
    preview?: boolean
}

export const NextBackButtons: React.FC<NextBackButtonsProps> = (props: NextBackButtonsProps) => {
  if (props.preview) { return <></> }

  return (
    <>
      <hr />
      <div className="clearfix">
        <Button variant="primary" id="btnNext" className="emdg-btn float-right" onClick={props.onNext} disabled={props.nextDisabled} style={{ display: props.onNext ? '' : 'none' }}>
          {props.nextLabel || 'Save & Next'}
        </Button>
        <Button id="btnBack"  className="emdg-btn emdg-btn--secondary float-left" onClick={props.onBack} style={{ display: props.onBack ? '' : 'none' }}>
          {props.backLabel || 'Back'}
        </Button>
      </div>
    </>
  )
}
